import React from "react";
import PropTypes from "prop-types";
import {AListItem} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";

const BulkDeleteMenuItem = ({enabled = false, setOpenModal}) => {
  const {t} = useTranslation();

  return (
    <AListItem
      id="deleteMenuItem"
      disabled={!enabled}
      onClick={() => enabled && setOpenModal(true)}>
      {t("investigate.savedInvestigations.actions.deleteSelected")}
    </AListItem>
  );
};

BulkDeleteMenuItem.propTypes = {
  enabled: PropTypes.bool,
  setOpenModal: PropTypes.func
};

export default BulkDeleteMenuItem;
